export const setupMapaFarmacias = () => {
  if (document.body.classList.contains("farmacias")) {
    const toggleMapBtn = document.querySelectorAll(".ver_mapa__btn");

    const mapContainer = document.querySelector(".template_listado__mapa");

    toggleMapBtn.forEach((btn) =>
      btn.addEventListener("click", (e) => {
        if (e.target.classList.contains("hide-map")) {
          mapContainer.classList.remove("hide-map");
          e.target.classList.remove("hide-map");
          if (window.visualViewport.width > 970) {
            e.target.innerText = "Ver listado";
          }
        } else {
          mapContainer.classList.add("hide-map");
          e.target.classList.add("hide-map");
          if (window.visualViewport.width > 970) {
            e.target.innerText = "Ver mapa";
          }
        }
      })
    );

    //google maps
    const sucursales = [
      {
        nombre: "Farmacia Del Prado",
        position: { lat: -34.606, lng: -58.428 },
        link: "/clinica-single.html",
      },
      {
        nombre: "Farmacia El Puente",
        position: { lat: -34.618, lng: -58.435 },
        link: "/clinica-single.html",
      },
      {
        nombre: "Farmacia SiFarma",
        position: { lat: -34.634, lng: -58.412 },
        link: "/clinica-single.html",
      },
      {
        nombre: "Framacia Santos",
        position: { lat: -34.607, lng: -58.412 },
        link: "/clinica-single.html",
      },
    ];

    // Centrar el mapa en la primera sucursal
    const centro = { lat: sucursales[0].lat, lng: sucursales[0].lng };

    // Initialize and add the map
    let map;

    async function initMap() {
      // Request needed libraries.
      //@ts-ignore
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary(
        "marker"
      );

      // The map, centered at Uluru
      map = new Map(document.getElementById("contenedor-mapa"), {
        zoom: 14,
        center: sucursales[0].position,
        mapId: "DEMO_MAP_ID",
      });

      sucursales.forEach((sucursal) => {
        const placeTag = document.createElement("a");

        placeTag.className = "place-tag";
        placeTag.href = sucursal.link;
        placeTag.textContent = sucursal.nombre;
        const marker = new AdvancedMarkerElement({
          map: map,
          position: sucursal.position,
          content: placeTag,
        });
      });
    }

    initMap();
  }
};
